import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { NavItem, Nav } from "react-bootstrap";

class AdminNavbarLinks extends Component {
  render() {
    
    return (
      <div>
        <Nav>
          <NavItem eventKey={1} href="#">
            
            <p className="hidden-lg hidden-md">Dashboard</p>
          </NavItem>
          
        
        </Nav>
        <Nav pullRight>
          
          
          <NavItem eventKey={3} href="#">
            
            <Link to={"/api/logout"}>Log out</Link>
          </NavItem>
        </Nav>
      </div>
    );
  }
}

export default AdminNavbarLinks;
